import { TileSkeleton } from '@rossum/components/tile';
import { Skeleton, Stack } from '@rossum/ui/material';

const QueueTileSkeleton = () => (
  <TileSkeleton
    skeletons={['title', 'description', 'endChips']}
    hasContextMenu
    hasTo
  />
);

export const QueueTilesSkeleton = () => (
  <Stack spacing={1}>
    <QueueTileSkeleton />
    <QueueTileSkeleton />
    <QueueTileSkeleton />
  </Stack>
);

export const WorkspaceSectionSkeleton = () => (
  <Stack spacing={2}>
    <Skeleton variant="text" width={200} height={32} />
    <QueueTilesSkeleton />
  </Stack>
);
